import React from "react";
import { useField } from "formik";
import styled from "styled-components";
import { InputPropsWithoutRef } from "react-html-props";
import FieldErrorMessage from "./FieldErrorMessage";

const CheckboxField = (props: Props) => {
  const { label, id, ...otherProps } = props;
  const [field] = useField({ ...props, type: "checkbox" });

  return (
    <FieldWrapper>
      <CheckboxLabel htmlFor={id}>
        <CheckboxInput {...field} {...otherProps} id={id} type="checkbox" />
        {label}
      </CheckboxLabel>
      <FieldErrorMessage name={otherProps.name} />
    </FieldWrapper>
  );
};

interface Props extends InputPropsWithoutRef {
  label: string;
  name: string;
}

const FieldWrapper = styled.div`
  font-family: ${({ theme }) => theme.font};
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.colors.text};
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
`;

const CheckboxInput = styled.input`
  margin: 0;
  margin-right: 0.5rem;
  display: inline-block;

  :focus {
    outline-color: ${({ theme }) => theme.colors.primary};
  }
`;

export default CheckboxField;
